export function Process() {
  const steps = [
    {
      num: "01",
      title: "Consultation",
      desc: "Share your vision and requirements with our expert team.",
    },
    {
      num: "02",
      title: "Design Proposal",
      desc: "Receive customized design plans tailored to your taste.",
    },
    {
      num: "03",
      title: "Execution",
      desc: "We bring your dream to reality with expert precision.",
    },
  ]

  return (
    <section className="border-t border-gray-200 py-20">
      <div className="mx-auto max-w-[1400px] px-8">
        <div className="reveal text-center">
          <p className="text-[11px] font-light tracking-[0.3em] text-gray-400 uppercase">
            How It Works
          </p>
          <h2 className="font-heading mt-3 text-[40px] leading-[1.15] text-navy sm:text-[48px]">
            OUR EASY PROCESS
          </h2>
          <p className="mx-auto mt-4 max-w-lg text-[15px] font-light leading-relaxed text-gray-400">
            Experience hassle-free interior transformation in just a few simple steps
            with Design Inside by Vicky.
          </p>
        </div>

        <div className="relative mt-16 grid gap-8 md:grid-cols-3">
          {/* Connecting line */}
          <div className="absolute top-10 left-[16%] hidden h-[1px] w-[68%] bg-gray-200 md:block" />

          {steps.map((step) => (
            <div key={step.num} className="reveal group text-center">
              <div className="relative mx-auto flex h-20 w-20 items-center justify-center border border-gray-200 bg-white transition-all duration-300 group-hover:border-navy">
                <span className="font-heading text-2xl text-navy">{step.num}</span>
              </div>
              <h3 className="font-heading mt-5 text-xl text-navy">{step.title}</h3>
              <p className="mt-2 text-[13px] font-light leading-relaxed text-gray-400">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
